import React from 'react';
import { 
  AgregatorColorImg, 
  PlatformColorImg, 
  RoomColorImg, 
  PammColorImg,
} from './elements';
import { 
  PageWrapper,
  FlexDiv, 
  Text, 
  Container, 
} from '@Main/elements';
import { DownloadFile } from '@helpers/DownloadFile';
import { Margin, P } from '@helpers';

export const AdditionalColors = ({getFileUrl, t}) => {
    return (
      <PageWrapper>
        <Container paddingTop="103px" marginLeft='102px' marginRight='38px' paddingBottom='107px'>
          <P weight='400' size='25px' height='20px'>{t("Additional background colors")}</P>
          <FlexDiv>
            <div>
              <Text width='293px' paddingAffterText="50px" paddingBefforeText="45px">
                <p>
                  {t("Other background colors may be used for the site and marketing content. These colors should match the official colors of Soft-FX products. In the case of additional colors, it is acceptable to not use a gradient.")}
                </p>
              </Text>
              <DownloadFile fileName='additional_background_colors' file={getFileUrl("additional_background_colors")}/>
            </div>
            <div>
              <FlexDiv marginTop="30px">
                <Margin marginLeft='31px'>
                  <AgregatorColorImg/>
                </Margin>
                <Margin marginLeft='31px'>
                  <RoomColorImg/>
                </Margin>
              </FlexDiv>
              <FlexDiv marginTop='59px' marginBottom='68px'>
                <Margin marginLeft='31px'>
                  <PlatformColorImg/>
                </Margin>
                <Margin marginLeft='31px'>
                  <PammColorImg/>
                </Margin>
              </FlexDiv>
            </div>
          </FlexDiv>
        </Container>
     </PageWrapper>
  );
};
